/**
 * Service Dependencies
 */
import {
    LOGIN_URL,
    JWT_CHECK_URL
} from '../router/paths'
import http from './HttpService'

/**
 * Attempt to authenticate the user
 *
 * @param  {Object} credentials
 * @return {Promise}
 */
export const authenticate = (credentials) => {
    return http.post(LOGIN_URL, credentials)
        .then(res => Promise.resolve(res.data.token))
        .catch(err => Promise.reject(err))
}

/**
 * Validate a JWT token that exists in local storage
 *
 * @return {Promise}
 */
export const validateToken = () => {
    return http.post(JWT_CHECK_URL, {
        token: window.localStorage.getItem('id_token')
    })
}

/**
 * Save the JWT to local storage
 *
 * @param  {String} token
 * @return {Void}
 */
export const setToken = (token) => {
    window.localStorage.setItem('id_token', token)
}

/**
 * Remove the JWT in local storage
 *
 * @return {Void}
 */
export const removeToken = () => {
    window.localStorage.removeItem('id_token')
}

/**
 * Change the user's password
 *
 * @param  {Object} payload
 * @return {Promise}
 */
export const changePassword = (payload = {}) => {
    return http.post('auth/change-password/', payload)
}

/**
 * Request a password reset email from the API
 *
 * @param  {String} email
 * @return {Promise}
 */
export const sendResetEmail = (email = null) => {
    return http.post('auth/password-reset/', {
        email: email
    })
}

/**
 * Check the validity of a password reset token
 *
 * @param  {String} token
 * @return {Promise}
 */
export const checkResetToken = (token = null) => {
    return http.get(`auth/confirm-password-reset/${token}/`)
}

/**
 * Change the user's password
 *
 * @param  {Object} payload
 * @param  {String} token
 * @return {Promise}
 */
export const requestPasswordChange = (payload = {}, token = null) => {
    return http.post(`auth/confirm-password-reset/${token}/`, payload)
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js